import LinkIcon from '@mui/icons-material/Link';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import type { ICellRendererParams } from 'ag-grid-community';

export const RelationRenderer = (props: ICellRendererParams) => {
  const { value } = props;
  return value ? <LinkIcon /> : <LinkOffIcon htmlColor='#D0D0D0' />;
};
